import React, { useState } from "react";
import { ArrowRight, ArrowLeft, Check, X, Eye } from "lucide-react";
import { Field } from "./ArtistForm";

export const QuestionnairePreview = ({ sections, onClose }) => {
  const [step, setStep] = useState(0);
  const [data, setData] = useState({});

  const TOTAL = sections?.length || 0;
  const section = sections?.[Math.min(step, TOTAL - 1)];
  const percent = TOTAL ? Math.round(((step + 1) / TOTAL) * 100) : 0;

  const onChange = (e) => {
    const { name, value } = e.target;
    setData((d) => ({ ...d, [name]: value }));
  };
  const onToggle = (name, opt) => {
    setData((d) => {
      const cur = Array.isArray(d[name]) ? d[name] : [];
      const next = cur.includes(opt) ? cur.filter((o) => o !== opt) : [...cur, opt];
      return { ...d, [name]: next };
    });
  };
  const noop = () => {};

  return (
    <div className="fixed inset-0 z-[60] bg-black/85 backdrop-blur-sm overflow-y-auto" data-testid="questionnaire-preview">
      <div className="sticky top-0 z-10 bg-[#070410]/95 backdrop-blur border-b border-white/10">
        <div className="max-w-5xl mx-auto px-5 sm:px-8 h-[60px] flex items-center justify-between">
          <div className="flex items-center gap-2 text-white/70 text-sm font-semibold">
            <Eye size={16} style={{ color: "#8cff00" }} /> Live preview — exactly what artists see
          </div>
          <button onClick={onClose} data-testid="close-preview-btn"
            className="inline-flex items-center gap-2 text-white/70 hover:text-white text-sm font-semibold">
            <X size={18} /> Close preview
          </button>
        </div>
      </div>

      <div className="py-10">
        {!section ? (
          <div className="max-w-5xl mx-auto px-5 sm:px-8 text-center text-white/60 py-20">
            Add at least one section with a field to preview the questionnaire.
          </div>
        ) : (
          <div className="max-w-5xl mx-auto px-5 sm:px-8">
            <div className="mb-6">
              <p className="kicker" style={{ color: "#d8b4fe" }}>Section {step + 1} of {TOTAL}</p>
              <div className="flex items-end justify-between gap-4 mt-3">
                <h2 className="font-ui font-extrabold uppercase text-white text-[1.9rem] sm:text-[2.3rem] leading-none">{section.title}</h2>
                <span className="font-ui font-bold text-[1.05rem]" style={{ color: "#8cff00" }}>{percent}%</span>
              </div>
              <div className="progress-track mt-4"><div className="progress-fill" style={{ width: `${percent}%` }} /></div>
            </div>

            <div className="hss-card p-6 sm:p-9" key={step}>
              <div className="fade-up">
                {section.intro && <p className="text-white/55 text-[0.95rem] mb-7">{section.intro}</p>}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-6">
                  {(section.fields || []).map((f) => (
                    <Field key={f.name} field={f} data={data} onChange={onChange} onToggle={onToggle} onFile={noop} error={false} uploads={{}} />
                  ))}
                </div>
                <div className="flex items-center justify-between mt-9">
                  {step > 0 ? (
                    <button onClick={() => setStep((s) => s - 1)} className="inline-flex items-center gap-2 text-white/70 hover:text-white transition-colors font-ui font-semibold text-sm uppercase tracking-wider">
                      <ArrowLeft size={17} /> Back
                    </button>
                  ) : (<span />)}
                  {step < TOTAL - 1 ? (
                    <button onClick={() => setStep((s) => s + 1)} className="btn-green">Continue <ArrowRight size={17} /></button>
                  ) : (
                    <button disabled className="btn-green opacity-60 cursor-not-allowed">Submit <Check size={17} /></button>
                  )}
                </div>
              </div>
            </div>

            <p className="text-center text-white/35 text-[0.82rem] mt-6">
              This is a preview. Submitting and file uploads are disabled here.
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default QuestionnairePreview;
